import React, { ReactHTMLElement, useEffect, useState } from 'react'
import { Tooltip, Empty } from '@arco-design/web-react'
import { IconFullScreen } from '@arco-iconbox/react-aidb-v2'
import ModalCustom from '../../components/ModalCustom'

import './style/index.less'

interface Props {
  top?: number
  right?: number
  width?: number
  title: string
  content: React.ReactElement
  visible: boolean
  setVisible: (boolean) => void
  onClick?: () => void
}

function Amplify(props: Props) {
  const { top, right, width, title, content, visible, setVisible, onClick } =
    props

  return (
    <div
      className="amplify"
      style={{
        top: top ? top + 'px' : '0',
        marginRight: right ? right + 'px' : '0',
      }}>
      <Tooltip content={'放大'}>
        <IconFullScreen
          useCurrentColor={true}
          onClick={() => {
            setVisible(true)
            if (onClick) onClick()
          }}
        />
      </Tooltip>

      <ModalCustom
        width={width ? `${width}px` : '650px'}
        title={null}
        visible={visible}
        close={() => setVisible(false)}
        content={
          <div className="content">
            <div className="title">{title ? title : '正文内容'}</div>
            {content ? (
              <div className="text">{content}</div>
            ) : (
              <div className="text textEmpty">
                <Empty />
              </div>
            )}
            {/* 按钮 */}
          </div>
        }
      />
    </div>
  )
}

export default Amplify
